export default __webpack_public_path__ + "images/2e9c95e56d88df069e2169f2be8e5a87.jpg";